module.exports = __webpack_public_path__ + "static/media/livros1.c2636d4b.png";